﻿export const initVerduurzamingPage = () => {
    initProductInformation();
    initAanvraagForm();
    initInterestOfferDownload();
    initMortgageOffer();
};

const initProductInformation = () => {
    const productInformationNextBtn = document.querySelector('[data-role="product-info-next-button"]');
    const sustainabilityAcceptTermsCheckbox = document.querySelector('[data-role="sustainability-accept-terms-checkbox"]');
    
    if (!productInformationNextBtn || !sustainabilityAcceptTermsCheckbox) {
        return;
    }

    const handleSustainabilityTermsSubmit = (event) => {
        if (sustainabilityAcceptTermsCheckbox.checked) {
            productInformationNextBtn.setAttribute("loading", "true");
        }
    }

    productInformationNextBtn.addEventListener('click', handleSustainabilityTermsSubmit);
}

const initMortgageOffer = () => {
    const form = document.getElementById('UploadHypotheekOfferte');

    if (!form) {
        return;
    }

    const requiredFilesAttr = form.getAttribute('data-required-files');
    let filesNeeded = Number.parseInt(requiredFilesAttr ?? '0', 10);

    if (!Number.isFinite(filesNeeded) || filesNeeded < 0) {
        filesNeeded = 0;
    }

    const warning = document.getElementById('mortgage-offer-required-warning');

    const updateWarning = () => {
        if (!warning) return;

        warning.hidden = filesNeeded === 0;
    };

    document.addEventListener('dropzone-required-file-added', (event) => {
        const count = (event && event.detail && Number(event.detail.count)) || 1;
        filesNeeded = Math.max(0, filesNeeded - count);
        updateWarning();
    });

    document.addEventListener('dropzone-required-file-removed', () => {
        filesNeeded += 1;
        updateWarning();
    });

    form.addEventListener('submit', (event) => {
        if (filesNeeded > 0) {
            event.preventDefault();
            event.stopImmediatePropagation();
            updateWarning();

            if (warning && typeof warning.scrollIntoView === 'function') {
                warning.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    });

    updateWarning();
};

const initAanvraagForm = () => {
    const form = document.getElementById('aanvraagform');
    const submitBtn = document.querySelector('[data-role="aanvraag-request-form-submit-btn"]');
    const incomeSelects = document.querySelectorAll('[data-role="aanvraag-income-select"]');
    const allowedSourcesEl = document.querySelector('[data-role="aanvraag-allowed-income-sources"]');
    const bkrLoanSelects = document.querySelectorAll('[data-role^="aanvraag-bkr-debt-select-"]');
    const step1 = document.getElementById('step1');
    const step2 = document.getElementById('step2');
    const applicationAmount = document.getElementById('ApplicationAmount');
    const sustainabilityLoanAmount = document.getElementById('SustainabilityLoanAmount');
    const sustainabilityLoanMonthlyAmount = document.getElementById('SustainabilityLoanMonthlyAmount');

    if (!form || !submitBtn || !applicationAmount) {
        return;
    }

    let previousApplicationAmount = null;
    let monthlyAmountAbortController = null;

    const allowedSources = allowedSourcesEl
        ? JSON.parse(allowedSourcesEl.value)
        : [];

    const parseAmount = value => {
        if (value === null || value === undefined || value === '') {
            return null;
        }

        let normalizedValue = String(value)
            .trim()
            .replace(/\s/g, '')
            .replace(/[^\d,.-]/g, '');

        if (!normalizedValue) {
            return null;
        }

        const hasComma = normalizedValue.includes(',');
        const hasDot = normalizedValue.includes('.');

        if (hasComma && hasDot) {
            normalizedValue = normalizedValue
                .replace(/\./g, '')
                .replace(',', '.');
        } else if (hasComma) {
            normalizedValue = normalizedValue.replace(',', '.');
        } else if (hasDot) {
            const dotParts = normalizedValue.split('.');
            const lastPart = dotParts[dotParts.length - 1];

            if (dotParts.length > 2 || lastPart.length === 3) {
                normalizedValue = normalizedValue.replace(/\./g, '');
            }
        }

        const amount = Number(normalizedValue);

        return Number.isFinite(amount) ? amount : null;
    };

    const formatAmount = amount =>
        amount.toLocaleString('nl-NL', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

    const getNumberAttribute = (element, attributeName) => {
        const value = element.getAttribute(attributeName);

        return parseAmount(value);
    };  

    const setApplicationAmountData = () => {
        const amount = parseAmount(applicationAmount.value);

        if (amount === null) {
            applicationAmount.setAttribute('data-amount', '');
            return null;
        }

        applicationAmount.setAttribute('data-amount', String(amount));

        return amount;
    };

    const formatApplicationAmount = () => {
        const amount = setApplicationAmountData();

        if (amount === null) {
            return null;
        }

        applicationAmount.value = formatAmount(amount);

        return amount;
    };

    const isApplicationAmountValid = amount => {
        if (amount === null) {
            return false;
        }

        const min = getNumberAttribute(applicationAmount, 'data-val-range-min');
        const max = getNumberAttribute(applicationAmount, 'data-val-range-max');

        if (min !== null && amount < min) {
            return false;
        }

        if (max !== null && amount > max) {
            return false;
        }

        return true;
    };

    const setSubmitState = (loading = false) => {
        submitBtn.setAttribute('aria-disabled', 'false');

        if (loading) {
            submitBtn.setAttribute('loading', 'true');
            return;
        }

        submitBtn.removeAttribute('loading');
    };

    const showStep = stepNumber => {
        if (!step1 || !step2) {
            return;
        }

        step1.style.display = stepNumber === 1 ? '' : 'none';
        step2.style.display = stepNumber === 2 ? '' : 'none';
    };

    const selectedIncomeValues = () =>
        Array.from(incomeSelects)
            .map(select => parseInt(select.value, 10))
            .filter(value => !Number.isNaN(value));

    const noneAllowed = () => {
        const values = selectedIncomeValues();

        return values.length > 0 &&
            values.every(value => !allowedSources.includes(value));
    };

    const setMonthlyAmountUnavailable = () => {
        if (sustainabilityLoanAmount) {
            sustainabilityLoanAmount.textContent = '-,--';
        }

        if (sustainabilityLoanMonthlyAmount) {
            sustainabilityLoanMonthlyAmount.textContent = '-,--';
        }
    };

    const parseResponseText = rawData => {
        try {
            return JSON.parse(rawData);
        } catch {
            return rawData;
        }
    };

    const getMonthly = async () => {
        const amount = setApplicationAmountData();
        const isValidAmount = isApplicationAmountValid(amount);
        
        if (!isValidAmount) {
            setMonthlyAmountUnavailable();
            return;
        }

        if (sustainabilityLoanAmount) {
            sustainabilityLoanAmount.textContent = formatAmount(amount);
        }

        if (previousApplicationAmount === amount) {
            return;
        }

        previousApplicationAmount = amount;

        const token = form.querySelector('input[name="__RequestVerificationToken"]')?.value;
        const url = `/Verduurzamingsaanvraag/GetMonthlyAmount?amount=${encodeURIComponent(amount)}`;
        
        try {
            if (monthlyAmountAbortController) {
                monthlyAmountAbortController.abort();
            }

            monthlyAmountAbortController = new AbortController();

            const headers = {
                'X-Requested-With': 'XMLHttpRequest'
            };
            
            if (token) {
                headers.RequestVerificationToken = token;
            }

            const response = await fetch(url, {
                method: 'POST',
                credentials: 'same-origin',
                headers,
                signal: monthlyAmountAbortController.signal
            });

            const rawData = await response.text();

            if (!response.ok) {
                console.error('GetMonthlyAmount failed', response.status, rawData);
                throw new Error('GetMonthlyAmount failed');
            }

            const monthlyAmount = parseResponseText(rawData);

            if (sustainabilityLoanMonthlyAmount) {
                sustainabilityLoanMonthlyAmount.textContent = monthlyAmount;
            }
        } catch (error) {
            if (error.name === 'AbortError') {
                return;
            }

            previousApplicationAmount = null;

            if (sustainabilityLoanMonthlyAmount) {
                sustainabilityLoanMonthlyAmount.textContent = '-,--';
            }
        }
    };

    const formatAmountOnly = () => {
        formatApplicationAmount();
    };

    const debounce = (callback, delay) => {
        let timeoutId;

        return () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(callback, delay);
        };
    };

    incomeSelects.forEach(select => {
        select.addEventListener('change', () => {
            setSubmitState(false);
        });
    });

    const updateMonthlyDebounced = debounce(() => {
        getMonthly();
    }, 300);

    applicationAmount.addEventListener('input', updateMonthlyDebounced);
    applicationAmount.addEventListener('change', formatAmountOnly);
    applicationAmount.addEventListener('blur', formatAmountOnly);

    form.addEventListener('submit', event => {
        const step1Visible = !step1 || step1.style.display !== 'none';

        if (step1Visible && noneAllowed()) {
            event.preventDefault();
            showStep(2);
            setSubmitState(false);
            return;
        }

        setSubmitState(true);
    });

    if (step2) {
        const step2BackBtn = step2.querySelector('sds-button[variant="secondary"]');

        if (step2BackBtn) {
            step2BackBtn.addEventListener('click', event => {
                event.preventDefault();
                showStep(1);

                if (typeof form.reset === 'function') {
                    form.reset();
                }

                previousApplicationAmount = null;
                setSubmitState(false);
                updateAmountOnBlur();
            });
        }
    }

    bkrLoanSelects.forEach(select => {
        const role = select.getAttribute('data-role') ?? '';
        const applicantIndexFromRole = role.replace('aanvraag-bkr-debt-select-', '');
        const applicantIndex = applicantIndexFromRole || select.getAttribute('data-applicant-index');

        const toggleUnregisteredLoans = () => {
            const unregistered = document.querySelector(
                `[data-role="aanvraag-bkr-loans-unregistered-${applicantIndex}"]`
            );

            if (!unregistered) {
                return;
            }

            unregistered.hidden = String(select.value).toLowerCase() !== 'true';
        };

        select.addEventListener('change', toggleUnregisteredLoans);
        toggleUnregisteredLoans();
    });

    window.addEventListener('pageshow', () => {
        setSubmitState(false);
        getMonthly();
    });

    updateAmountOnBlur();
    setSubmitState(false);
};

const initInterestOfferDownload = () => {
    const link = document.getElementById('interest-offer-download')
    const error404 = document.getElementById('interest-offer-error-404')
    const error500 = document.getElementById('interest-offer-error-500')

    if (!link) {
        return
    }

    let isDownloading = false

    const hideErrors = () => {
        if (error404) error404.hidden = true
        if (error500) error500.hidden = true
    }

    const showError = status => {
        if (error404) error404.hidden = status !== 404
        if (error500) error500.hidden = status === 404
    }

    link.addEventListener('click', async event => {
        event.preventDefault()

        if (isDownloading) {
            return
        }

        isDownloading = true
        hideErrors()

        try {
            const response = await fetch(link.href)

            if (!response.ok) {
                showError(response.status)
                return
            }

            const blob = await response.blob()
            const downloadUrl = URL.createObjectURL(blob)
            const downloadLink = document.createElement('a')

            downloadLink.href = downloadUrl
            downloadLink.download = link.getAttribute('download') || 'RenteAanbod.pdf'
            downloadLink.click()

            URL.revokeObjectURL(downloadUrl)
        } catch {
            showError(500)
        } finally {
            isDownloading = false
        }
    })
}